import { useState, useEffect, useCallback } from 'react';
import { ENDPOINTS, normalizeCarriers, normalizeNameCountMap, normalizeDataUsage } from '../api/api';

export function useOverviewData() {
  const [state, setState] = useState({ loading: true, error: null });
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  useEffect(() => {
    const safe = (promise) => promise.catch(() => null);

    Promise.all([
      fetch(ENDPOINTS.summary).then((r) => r.json()),
      safe(fetch(ENDPOINTS.globalDataUsage).then((r) => r.json())),
    ])
      .then(([summary, dataUsage]) => {
        if (!summary) {
          setState({ loading: false, error: 'Failed to load summary' });
          return;
        }
        setState({
          loading: false,
          error: null,
          stats: {
            devices:   (summary.totalDevices  ?? 0).toLocaleString(),
            schools:   (summary.totalSchools  ?? 0).toLocaleString(),
            circuits:  (summary.totalCircuits ?? 0).toLocaleString(),
            districts: (summary.totalDistrict ?? 0).toLocaleString(),
          },
          carriers:          normalizeCarriers(summary.carrierStats ?? []),
          devicesByDistrict: normalizeNameCountMap(summary.devicesPerRegion ?? {}),
          dataUsage:         normalizeDataUsage(Array.isArray(dataUsage) ? dataUsage : []),
          apps:              [],
        });
      })
      .catch((err) => setState({ loading: false, error: err.message }));
  }, [refreshKey]);

  return { ...state, refresh };
}
